import './App.css';
import { Typewriter } from 'react-simple-typewriter';

function App() {
  return (
    <div className="container">
      <h1 className="typing-text">
        <Typewriter
          words={['Website under construction 🖌️🖌️🖌️...']}
          loop={0} // 0 = infinite, or set number of times
          cursor
          cursorStyle="|"
          typeSpeed={70}
          deleteSpeed={50}
          delaySpeed={1000}
        />
      </h1>
      <p className="message">We are working hard to bring something as vibrant as your moments</p>



      {/* Footer Section */}
      <footer className="footer">
        <p className="footer-text">
        <span className="footer-item">  {/* First footer item (Owner link) */}
            Owned by <a href="https://linkedin.com/in/sangitha-vijayan/" className="footer-link" target="_blank" rel="noopener noreferrer"> Sangitha Vijayan</a>
        </span>
        <span className="footer-item">  {/* Second footer item (Marketer link) */}
          Marketed by <a href="https://shdigitaltrends.in/" className="footer-link" target="_blank" rel="noopener noreferrer"> SHDigitalTrends</a>
        </span>
        <span className="footer-item">  {/* Second footer item (Developer link) */}
          Developed by <a href="https://linkedin.com/in/ramananat" className="footer-link" target="_blank" rel="noopener noreferrer"> Ramanan AT</a> 
        </span>
        </p>
      </footer>
    </div>
  );
}

export default App;
